module.exports = __webpack_public_path__ + "img/de.0cc650a4.svg";